import { render, staticRenderFns } from "./day-times.vue?vue&type=template&id=540a7544&scoped=true&"
import script from "./day-times.vue?vue&type=script&lang=js&"
export * from "./day-times.vue?vue&type=script&lang=js&"
import style0 from "./day-times.vue?vue&type=style&index=0&id=540a7544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a7544",
  null
  
)

export default component.exports